<template>
    <div id="index">
      <el-dialog title="注册账户" :visible="registerDialog" width="20%" :before-close="registerClose">
        <div class="dialogFrom">
          <el-input placeholder="请输入您的手机号" v-model="phone"></el-input>
          <div>
            <el-input placeholder="请输入短信验证码" v-model="code"></el-input>
            <el-button type="info" :disabled="disabled" @click="getCode" style="padding:0;width:90px;height:40px;line-height:40px;">{{codeText}}</el-button>
          </div>
          <el-input placeholder="设置密码" v-model="password" style="margin-bottom:10px"></el-input>
          <p style="font-size:12px;margin-bottom:10px"><b>*</b>  6-16个字符，支持大小写字母、数字、字符组合，且不能为纯数字</p>
          <!-- <el-input placeholder="重置密码" v-model="input2"></el-input> -->
          <p><el-checkbox v-model="checked">注册即表示您同意</el-checkbox> <u @click="goUserAgreement">《亳药师用户注册协议》</u></p>
          <el-button type="warning" @click="getRegister">注册</el-button>
        </div>
      </el-dialog>
      
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        disabled:false,
        codeText:'获取验证码',
        loginDialog: false,
        registerDialog:false,
        checked:false,
        password: "",
        phone: "",
        acount:"",
        code:""

      }
    },
    mounted() {
    },
    methods: {
      goUserAgreement(){
        this.$router.push('/UserAgreement')
      },
      getCode(){
        this.$fetch('getCode',{phone:this.phone}).then(res => {
          if(this.phone == null || this.phone == ''){
            alert("手机号不能为空！")
          }else if(!/^1[0-9]{10}$/.test(this.phone)){
              alert("手机号格式不正确！")
          }else{
            let maxNum = 45;
            let oldCodeText = this.codeText;
            this.codeText = `${maxNum}s重新发送`; //初始显示倒计时
            let codeCountDown = setInterval(() => {
            this.disabled = true;
            let countDownNum = maxNum--;
            this.codeText = `${countDownNum}s重新发送`;
            if (countDownNum == 0) {
              //倒计时结束
              this.codeText = oldCodeText;
              clearInterval(codeCountDown);
              this.disabled = false;
            }
          }, 1000);
          }
        })  
      },
      getRegister(){
        if(this.checked == false){
          alert("请勾选注册协议")
        }
        this.$fetch('getRegister',{phone:this.phone,password:this.password,code:this.code}).then(res => {
          if(res.code == 200){
            this.registerDialog = false;
            this.$message({
              message: '注册成功,请登录',
              type: 'success'
            });
          }else{
            this.$message({
              message:res.message,
              type: 'warning'
            });
          }
        })
      },
      toRegister(){
        this.registerDialog = true;
      },
      registerClose(done) {
        this.registerDialog = false
      }
    }
  }
  </script>


// WEBPACK FOOTER //
// src/components/register.vue